<template>
  <div class="orgcontainer">
    <LastTrades :allCoins="coins" :sourc_coin="type" />
    <Market :allCoins="coins" @source_coin="(value) => (type = value)" />
    <simple-pagination
      v-if="totalPages"
      class="align-self-center my-2 pagination"
      :currentpage="page"
      :pages="totalPages"
      @changePage="cb"
    />
  </div>
</template>
<script>
import LastTrades from "../HomePage/LastTrades.vue";
import Market from "../HomePage/Market.vue";
import { Loop } from "@/library/reuseableFunction";
import SimplePagination from "@celdotro/vue-simplepagination";
export default {
  name: "MatketPublic",
  components: {
    LastTrades,
    Market,
    SimplePagination,
  },
  data() {
    return {
      type: "TOMAN",
      loop: undefined,
      coins: [],
      totalPages: "",
      page: 1,
    };
  },
  metaInfo: {
    title: "بازارها",
  },
  watch: {
    type() {
      this.setData();
    },
  },
  methods: {
    cb(e) {
      this.page = e;
      this.setData();
    },

    async setData() {
      const res = await this.$axios.get("/trades/market-info/v2", {
        params: {
          weeklyDataIncluded: true,
          source_coin: this.type,
          size: 15,
          page: this.page,
        },
      });
      this.totalPages = res.totalPages;
      this.coins = res.content;
    },
  },
  mounted() {
    if (!this.loop) {
      this.loop = new Loop(this.setData);
      this.loop.start();
    }
  },
  beforeDestroy() {
    this.loop.stop();
  },
};
</script>

<style lang="scss" scoped>
.align-self-center {
  align-self: center;
  margin-top: 1.5em;
}
.orgcontainer {
  padding-top: 40px !important ;
  @media (max-width: 1000px) {
    padding: 40px 0 !important;
  }
}
::v-deep .pagination button {
  background-color: var(--box);
  color: var(--light-gray);
}
</style>
<style>
.vspButton {
  height: 22px;
  padding: 2px 7px;
  font-size: 12px;
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: transparent;
}

button[class="vspButton"]:hover {
  background-color: #ffeee7;
  border: 1px solid var(--table-header);
}

.vspButton-selected {
  background-color: var(--table-header);
  color: white;
}

.vspButtonFast {
  background-color: #f4f8fb;
  color: #b5b9bc;
}
